import { getCurrentMonthYear } from '../../../helpers/utils/utils';
import type { MappedPrizeTier } from '../utils/prizeDrawUtils';

type MonthlyDropCardProps = {
  tiers: MappedPrizeTier[];
  loading: boolean;
};

const tierClassName = (variant: MappedPrizeTier['variant']) => {
  if (variant === 'featured') return '';
  if (variant === 'gold') return ' sv-tier-gold';
  if (variant === 'silver') return ' sv-tier-silver';
  if (variant === 'bronze') return ' sv-tier-bronze';
  if (variant === 'bonus') return ' sv-tier-bonus';
  return '';
};

export const MonthlyDropCard = ({ tiers, loading }: MonthlyDropCardProps) => {
  const featured = tiers.find((t) => t.variant === 'featured');
  const standardTiers = tiers.filter((t) => t.variant !== 'featured');

  return (
    <div className='sv-monthly-wrap'>
      <div className='card sv-drop-card'>
        <div className='sv-drop-card-header'>
          <div>
            <div
              style={{
                fontFamily: 'var(--font-heading)',
                fontSize: 'var(--fs-section-title)',
                fontWeight: 700,
                color: '#F5DFA0',
                letterSpacing: '-.02em',
              }}
            >
              Monthly rent drop
            </div>
            <div
              style={{
                fontFamily: 'var(--font-body)',
                fontSize: 12,
                color: 'rgba(255,255,255,.35)',
                marginTop: 3,
              }}
            >
              one per member
            </div>
          </div>
          <span className='sv-badge-month' style={{ fontSize: 11 }}>
            {getCurrentMonthYear()}
          </span>
        </div>

        {loading ? (
          <div className='sv-tier' style={{ padding: '24px 22px', color: 'rgba(255,255,255,.4)' }}>
            Loading monthly drop…
          </div>
        ) : (
          <>
            {featured && (
              <div className='sv-feat-row'>
                <div className='sv-feat-l'>
                  <div className='sv-feat-icon'>🏆</div>
                  <div className='sv-feat-text'>
                    <div className='sv-feat-header'>
                      <div className='sv-feat-eyebrow'>★ Grand drop</div>
                      <div className='sv-feat-badge sv-feat-badge-inline'>
                        {featured.prize.quantity} available
                      </div>
                    </div>
                    <div className='sv-feat-label'>{featured.label}</div>
                    <div className='sv-feat-bar'>
                      <div
                        className='sv-feat-bar-fill'
                        style={{ width: `${featured.barWidthPct}%` }}
                      />
                    </div>
                  </div>
                </div>
                <div className='sv-feat-badge sv-feat-badge-side'>
                  {featured.prize.quantity} available
                </div>
              </div>
            )}

            {standardTiers.map((tier) => (
              <div
                key={tier.prize.prizeId}
                className={`sv-tier${tierClassName(tier.variant)}`}
              >
                <div className='sv-tier-icon'>{tier.variant === 'bonus' ? '+' : '$'}</div>
                <div className='sv-tier-label'>{tier.label}</div>
                <div className='sv-tier-qty'>
                  <div className='sv-tier-qty-num'>{tier.prize.quantity}</div>
                  <div className='sv-tier-qty-sub'>available</div>
                </div>
                <div className='sv-tier-bar'>
                  <div
                    className='sv-tier-bar-fill'
                    style={{ width: `${tier.barWidthPct}%` }}
                  />
                </div>
              </div>
            ))}
          </>
        )}
      </div>
    </div>
  );
};
